import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { BackgroundJobsProvider } from './contexts/BackgroundJobsContext';
import { BackgroundJobProgress } from './components/BackgroundJobProgress';
import { NotificationProvider } from './contexts/NotificationContext';
import { NotificationModal } from './components/NotificationModal';
import { ConfirmDialogProvider } from './contexts/ConfirmDialogContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';

// Build marker — pozwala zweryfikować czy bundle jest aktualny
// eslint-disable-next-line no-console
console.log('%c[EcomFlow] Frontend build: 1.34.7-iter3-nav-headers-login', 'color:#22c55e;font-weight:bold');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <NotificationProvider>
            <ConfirmDialogProvider>
              <BackgroundJobsProvider>
                <App />
                <BackgroundJobProgress />
              </BackgroundJobsProvider>
              <NotificationModal />
            </ConfirmDialogProvider>
          </NotificationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
